/*
 * zeroLabs Labor Produktseite B: die Geschichte unter den Kundenstimmen (sections/zl-produkt-geschichte.liquid).
 * Nur eins: Filme laufen erst, wenn man sie antippt, und halten beim zweiten Tippen an (Antwort statt Ablauf).
 * Wer aus dem Bild scrollt, hält den Film an. Alles hängt am Dokument, weil das Labor die Geschichte beim
 * Sortenwechsel austauscht (assets/zl-produkt-buehne.js, darunter()).
 */
(() => {
  if (window.zlGeschichte) return;
  window.zlGeschichte = true;

  const zeige = (figur, an) => {
    figur.classList.toggle('is-an', an);
    const knopf = figur.querySelector('.zl-g__abspielen');
    if (knopf) knopf.setAttribute('aria-label', an ? knopf.dataset.aus : knopf.dataset.an);
  };

  document.addEventListener('click', (e) => {
    const figur = e.target.closest('[data-zl-g-film]');
    if (!figur) return;
    const film = figur.querySelector('video');
    if (!film) return;
    /* Der Knopf antwortet sofort, auch wenn der Film noch lädt. Klappt das Abspielen nicht, geht er zurück. */
    if (film.paused && !figur.classList.contains('is-an')) {
      zeige(figur, true);
      film.play().catch(() => zeige(figur, false));
    } else {
      film.pause();
      zeige(figur, false);
    }
  });

  ['playing', 'pause', 'ended'].forEach((typ) => {
    document.addEventListener(typ, (e) => {
      if (e.target.dataset && e.target.dataset.zlGVorbereiten) return; /* Standbild holen ist kein Abspielen */
      const figur = e.target.closest && e.target.closest('[data-zl-g-film]');
      if (figur) zeige(figur, typ === 'playing');
    }, true);
  });

  /* Erstes Bild als Standbild: Safari am iPhone zeigt ohne Abspielen nichts. Kurz bevor ein Film ins Bild kommt,
     lädt er, spielt stumm einen Augenblick an und steht sofort wieder auf dem ersten Bild. Niemand sieht ihn laufen. */
  const standbild = () => {
    document.querySelectorAll('video[data-zl-g-standbild]').forEach((film) => {
      if (!film.offsetParent) return;
      const r = film.getBoundingClientRect();
      if (r.top > window.innerHeight * 2 || r.bottom < -window.innerHeight) return;
      film.removeAttribute('data-zl-g-standbild');
      film.preload = 'auto';
      film.dataset.zlGVorbereiten = '1';
      const zurueck = () => {
        film.pause();
        try { film.currentTime = 0; } catch (e) { /* egal */ }
        setTimeout(() => { delete film.dataset.zlGVorbereiten; }, 0);
      };
      const p = film.play();
      if (p && p.then) p.then(zurueck).catch(() => { delete film.dataset.zlGVorbereiten; });
      else zurueck();
    });
  };
  let wartet = 0;
  window.addEventListener('scroll', () => {
    if (wartet) return;
    wartet = requestAnimationFrame(() => {
      wartet = 0;
      standbild();
      document.querySelectorAll('[data-zl-g-film].is-an video').forEach((film) => {
        const r = film.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight || !film.offsetParent) film.pause();
      });
    });
  }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', standbild); else standbild();
  new MutationObserver(standbild).observe(document.documentElement, { attributes: true, attributeFilter: ['data-zl-darunter'] });

  /* ---------- Weitere Bilder (Regler "Weitere Bilder", html[data-zl-bilder]) ----------
     Vorrat: die Reihe "Wie es aussieht" in der Geschichte. Je nach Fassung bleibt sie stehen (reihe), wandert zwischen die Kapitel
     des gezeigten Konzepts (kapitel, baender) oder öffnet sich aus der Flasche oben (flasche). */
  const modus = () => document.documentElement.dataset.zlBilder || 'reihe';
  const vorrat = () => Array.from(document.querySelectorAll('[data-zl-g-bilder] .zl-g__bild:not([data-doppelt])'));

  const verteilen = () => {
    document.querySelectorAll('.zl-g__bildslot').forEach((x) => x.remove());
    const m = modus();
    if (m !== 'kapitel' && m !== 'baender') return;
    const richtung = Array.from(document.querySelectorAll('.zl-g__richtung')).find((r) => r.offsetParent);
    if (!richtung) return;
    /* Kapitel des gezeigten Konzepts, ohne den Schluss. Im Datenblatt die Zeilen. */
    const kapitel = Array.from(richtung.querySelectorAll(':scope > .zl-g__kapitel, :scope > .zl-g__szene, :scope > .zl-g__fa, .zl-g__blatt > .zl-g__zeile'))
      .filter((k) => !k.classList.contains('zl-g__schluss'));
    /* Bilder, die ein Konzept schon zeigt (Aufmachen, Moment), kommen nicht doppelt */
    const bilder = vorrat().filter((f) => !f.hasAttribute('data-genutzt'));
    kapitel.slice(0, -1).forEach((k, i) => {
      const f = bilder[i]; if (!f) return;
      const slot = document.createElement('div');
      slot.className = 'zl-g__bildslot' + (m === 'baender' ? ' zl-g__bildslot--band' : '');
      const fig = document.createElement('figure');
      const img = f.querySelector('img').cloneNode(true);
      img.sizes = m === 'baender' ? '100vw' : '(min-width: 1025px) 1300px, 100vw'; // token-ok: Bildgröße für den Browser, keine Gestaltung
      fig.append(img); slot.append(fig);
      k.after(slot);
    });
  };

  /* Die Flasche öffnet die Bilder */
  let galerie = null, offenVon = null;
  const schliessen = () => {
    if (!galerie) return;
    galerie.classList.remove('is-offen');
    document.documentElement.classList.remove('zl-g-galerie-offen');
    if (offenVon && offenVon.focus) offenVon.focus({ preventScroll: true });
  };
  const oeffnen = (x, y) => {
    const bilder = vorrat();
    if (!bilder.length) return;
    if (!galerie) {
      galerie = document.createElement('div');
      galerie.className = 'zl-g-galerie';
      galerie.setAttribute('role', 'dialog');
      galerie.setAttribute('aria-modal', 'true');
      galerie.setAttribute('aria-label', 'Bilder');
      galerie.innerHTML = '<button type="button" class="zl-g-galerie__zu" aria-label="Schließen"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" style="stroke-width: var(--zl-symbol-strich)" stroke-linecap="round"/></svg></button><div class="zl-g-galerie__reihe"></div><p class="zl-g-galerie__zahl" aria-live="polite"></p>';
      document.body.append(galerie);
      galerie.querySelector('.zl-g-galerie__zu').addEventListener('click', schliessen);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && galerie.classList.contains('is-offen')) schliessen(); });
      const reiheEl = galerie.querySelector('.zl-g-galerie__reihe');
      const zahl = () => {
        const n = reiheEl.children.length, i = Math.round(reiheEl.scrollLeft / Math.max(1, reiheEl.clientWidth)) + 1;
        galerie.querySelector('.zl-g-galerie__zahl').textContent = i + ' von ' + n;
      };
      reiheEl.addEventListener('scroll', zahl, { passive: true });
      /* nach unten ziehen schließt */
      let y0 = null;
      galerie.addEventListener('touchstart', (e) => { y0 = e.touches[0].clientY; }, { passive: true });
      galerie.addEventListener('touchmove', (e) => {
        if (y0 === null) return;
        const d = e.touches[0].clientY - y0;
        if (d > 0) galerie.style.transform = 'translateY(' + d * 0.5 + 'px)';
      }, { passive: true });
      galerie.addEventListener('touchend', (e) => {
        const d = (e.changedTouches[0].clientY - (y0 === null ? 0 : y0));
        galerie.style.transform = '';
        y0 = null;
        if (d > 120) schliessen(); // token-ok: Weg nach unten, ab dem die Bilder schließen
      }, { passive: true });
      galerie.zahl = zahl;
    }
    const reiheEl = galerie.querySelector('.zl-g-galerie__reihe');
    reiheEl.textContent = '';
    bilder.forEach((f) => {
      const fig = document.createElement('figure');
      const img = f.querySelector('img').cloneNode(true);
      img.loading = 'eager'; img.sizes = '100vw'; // token-ok: Bildgröße für den Browser
      fig.append(img); reiheEl.append(fig);
    });
    reiheEl.scrollLeft = 0;
    galerie.zahl();
    galerie.style.transformOrigin = (x || window.innerWidth / 2) + 'px ' + (y || window.innerHeight / 2) + 'px';
    offenVon = document.activeElement;
    document.documentElement.classList.add('zl-g-galerie-offen');
    requestAnimationFrame(() => { galerie.classList.add('is-offen'); galerie.querySelector('.zl-g-galerie__zu').focus({ preventScroll: true }); });
  };
  document.addEventListener('zl:flasche', (e) => {
    if (modus() !== 'flasche') return;
    oeffnen(e.detail && e.detail.x, e.detail && e.detail.y);
  });

  /* ---------- ZDF WISO: der Film lädt erst beim Tippen (Regler "ZDF WISO", Film) ----------
     Vorher keine Anfrage an YouTube. Beim Tippen kommt der Player von youtube-nocookie.com an unserer Stelle (start),
     er blendet weich über das Vorschaubild, sobald er geladen ist. Scrollt man weg, hält er an (über postMessage, ohne
     das Skript von YouTube). Ohne Skript bleibt der Link zu YouTube. */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-zl-g-wiso-start]');
    if (!a) return;
    const film = a.closest('[data-zl-g-wiso]');
    if (!film || !film.dataset.id) return;
    e.preventDefault();
    if (film.classList.contains('is-an')) return;
    film.classList.add('is-an');
    const f = document.createElement('iframe');
    const q = new URLSearchParams({ start: film.dataset.start || '0', autoplay: '1', playsinline: '1', rel: '0', modestbranding: '1', enablejsapi: '1', origin: location.origin });
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(film.dataset.id) + '?' + q.toString();
    f.title = film.dataset.titel || 'Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.allowFullscreen = true;
    /* Läuft der Film nicht von selbst los (Safari am iPhone erlaubt Ton nur nach einem Tippen im Player), startet er stumm
       an derselben Stelle. Ob er läuft, meldet der Player über postMessage (playerState 1), ohne das Skript von YouTube. */
    const ziel = 'https://www.youtube-nocookie.com';
    const sende = (func, args) => { try { f.contentWindow.postMessage(JSON.stringify({ event: 'command', func, args: args || [] }), ziel); } catch (err) { /* egal */ } };
    let laeuft = false;
    const hoeren = (ev) => {
      if (ev.origin !== ziel || ev.source !== f.contentWindow) return;
      let d; try { d = typeof ev.data === 'string' ? JSON.parse(ev.data) : ev.data; } catch (err) { return; }
      const zustand = d && d.info && d.info.playerState;
      if (zustand === 1) laeuft = true;
    };
    window.addEventListener('message', hoeren);
    f.addEventListener('load', () => {
      film.classList.add('is-bereit');
      try { f.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 'zl-wiso' }), ziel); } catch (err) { /* egal */ }
      setTimeout(() => { if (!laeuft) { sende('mute'); sende('seekTo', [Number(film.dataset.start || 0), true]); sende('playVideo'); } }, 1500); // token-ok: so lange darf der Film mit Ton anlaufen
    }, { once: true });
    a.append(f);
    a.removeAttribute('href');
    a.setAttribute('tabindex', '-1');
  });
  const filmPause = () => {
    document.querySelectorAll('[data-zl-g-wiso].is-bereit iframe').forEach((f) => {
      const r = f.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight || !f.offsetParent) {
        try { f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), 'https://www.youtube-nocookie.com'); } catch (err) { /* egal */ }
      }
    });
  };
  let filmWartet = 0;
  window.addEventListener('scroll', () => { if (!filmWartet) filmWartet = requestAnimationFrame(() => { filmWartet = 0; filmPause(); }); }, { passive: true });

  const tok = (n) => parseFloat(getComputedStyle(document.documentElement).getPropertyValue(n)) || 0;

  /* ---------- Pegel: die Balken füllen sich beim Scrollen (Regler "Beim Scrollen": pegel, alle) ----------
     Ziel ist der Scrollstand: leer, wenn die Tabelle --zl-g-scroll-start über dem unteren Rand steht, voll bei --zl-g-scroll-ende.
     Der Füllstand läuft dem Ziel über eine kritisch gedämpfte Feder hinterher: kein Überschwingen, immer ein weiches Ankommen,
     auch wenn der Daumen schnell ist, und genauso zurück beim Hochscrollen. */
  const pegelAn = () => ['pegel', 'alle'].includes(document.documentElement.dataset.zlScroll) && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pegel = new Map();
  let pegelRaf = 0, pegelZeit = 0;
  const pegelZiel = (r) => {
    const vh = window.innerHeight / 100; // token-ok: 1svh in px
    const start = tok('--zl-g-scroll-start') * vh, ende = tok('--zl-g-scroll-ende') * vh;
    const weg = window.innerHeight - r.getBoundingClientRect().top;
    return Math.max(0, Math.min(1, (weg - start) / (ende - start)));
  };
  const pegelZeichnen = (jetzt) => {
    pegelRaf = 0;
    const dt = Math.min(0.05, (jetzt - (pegelZeit || jetzt)) / 1000); // token-ok: höchstens 50 ms je Schritt, ms in s
    pegelZeit = jetzt;
    const w = tok('--zl-g-pegel-feder');
    let laeuft = false;
    pegel.forEach((z, r) => {
      const ziel = pegelZiel(r);
      z.v += (w * w * (ziel - z.x) - 2 * w * z.v) * dt; // token-ok: kritisch gedämpft
      z.x += z.v * dt;
      if (Math.abs(ziel - z.x) < 0.001 && Math.abs(z.v) < 0.001) { z.x = ziel; z.v = 0; } else laeuft = true; // token-ok: darunter steht der Balken
      r.style.setProperty('--g-fuell', z.x.toFixed(4));
    });
    if (laeuft) pegelRaf = requestAnimationFrame(pegelZeichnen); else pegelZeit = 0;
  };
  const pegelStart = () => {
    const an = pegelAn();
    document.querySelectorAll('.zl-g__tabelle-rahmen').forEach((r) => {
      if (an && r.querySelector('.zl-g__balken')) {
        if (!pegel.has(r)) { const x = pegelZiel(r); pegel.set(r, { x, v: 0 }); r.style.setProperty('--g-fuell', x.toFixed(4)); }
        r.classList.add('is-pegel');
      } else {
        pegel.delete(r);
        r.classList.remove('is-pegel');
        r.style.removeProperty('--g-fuell');
      }
    });
  };
  window.addEventListener('scroll', () => { if (pegel.size && !pegelRaf) pegelRaf = requestAnimationFrame(pegelZeichnen); }, { passive: true });
  window.addEventListener('resize', () => { if (pegel.size && !pegelRaf) pegelRaf = requestAnimationFrame(pegelZeichnen); }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pegelStart); else pegelStart();
  document.addEventListener('zl:darunter', pegelStart);
  new MutationObserver(pegelStart).observe(document.documentElement, { attributes: true, attributeFilter: ['data-zl-scroll', 'data-zl-darunter'] });

  /* ---------- Weitere Bilder: blättern mit zwei Knöpfen ----------
     Ein Tippen schiebt die Reihe um ein Bild weiter. Am Anfang tritt der Knopf nach links zurück, am Ende der nach rechts. */
  const blaetternAn = new WeakSet();
  const blaetternStart = () => {
    document.querySelectorAll('[data-zl-g-blaettern]').forEach((b) => {
      const reihe = b.parentElement.querySelector('.zl-g__bilder-reihe');
      if (!reihe || blaetternAn.has(b)) return;
      blaetternAn.add(b);
      const [zurueck, vor] = b.querySelectorAll('button');
      const stand = () => {
        const rest = reihe.scrollWidth - reihe.clientWidth;
        b.hidden = rest < 2;
        zurueck.setAttribute('aria-disabled', String(reihe.scrollLeft < 2));
        vor.setAttribute('aria-disabled', String(reihe.scrollLeft > rest - 2));
      };
      b.addEventListener('click', (e) => {
        const k = e.target.closest('button'); if (!k || k.getAttribute('aria-disabled') === 'true') return;
        const bild = reihe.querySelector('.zl-g__bild');
        const schritt = bild ? bild.getBoundingClientRect().width + parseFloat(getComputedStyle(reihe).columnGap || 0) : reihe.clientWidth;
        reihe.scrollBy({ left: schritt * Number(k.dataset.richtung), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      reihe.addEventListener('scroll', stand, { passive: true });
      /* erst wenn die Reihe ihre Breite kennt (Stylesheet und Bilder geladen), sonst bliebe der Knopf versteckt */
      if (window.ResizeObserver) new ResizeObserver(stand).observe(reihe);
      window.addEventListener('resize', stand, { passive: true });
      window.addEventListener('load', stand);
      stand();
    });
  };
  document.addEventListener('zl:darunter', blaetternStart);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', blaetternStart); else blaetternStart();

  /* ---------- Weitere Bilder: kein Foto doppelt ----------
     Zeigt die Seite ein Foto schon an anderer Stelle (Kapitel, Szene, Darunter), fehlt es in der Reihe. Gezählt wird nur,
     was gerade sichtbar ist, denn welche Stellen sichtbar sind, hängt von der Fassung ab. Verglichen wird der Dateiname. */
  const dateiname = (img) => (img.getAttribute('src') || '').split('?')[0].split('/').pop();
  const doppelteRaus = () => {
    document.querySelectorAll('[data-zl-g-bilder]').forEach((sek) => {
      const reihe = sek.querySelector('.zl-g__bilder-reihe'); if (!reihe) return;
      const anderswo = new Set(Array.from(document.querySelectorAll('img'))
        .filter((i) => !sek.contains(i) && !i.closest('.zl-g__bildslot, .zl-g-galerie') && i.getClientRects().length)
        .map(dateiname));
      let uebrig = 0;
      reihe.querySelectorAll('.zl-g__bild').forEach((f) => {
        const doppelt = anderswo.has(dateiname(f.querySelector('img')));
        f.toggleAttribute('data-doppelt', doppelt);
        if (!doppelt) uebrig += 1;
      });
      sek.hidden = uebrig === 0;
      reihe.dispatchEvent(new Event('scroll'));
    });
  };
  let doppeltPlan = 0;
  const doppelteBald = () => { cancelAnimationFrame(doppeltPlan); doppeltPlan = requestAnimationFrame(doppelteRaus); };
  document.addEventListener('zl:darunter', doppelteBald);
  new MutationObserver((ms) => { if (ms.some((m) => m.attributeName.startsWith('data-zl'))) doppelteBald(); }).observe(document.documentElement, { attributes: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', doppelteBald); else doppelteBald();
  window.addEventListener('load', doppelteBald);

  /* ---------- Tabellen, die seitlich weitergehen ----------
     Eine schmale Leiste unter der Tabelle zeigt den sichtbaren Teil und wo man ist, auch am iPhone, das Scrollbalken ausblendet. */
  const leisteZeichnen = (r, l) => {
    const rest = r.scrollWidth - r.clientWidth;
    l.style.setProperty('--anteil', (r.clientWidth / r.scrollWidth).toFixed(3));
    l.style.setProperty('--pos', (rest > 0 ? r.scrollLeft / rest : 0).toFixed(3));
  };
  const leisten = () => {
    document.querySelectorAll('.zl-g__tabelle-rahmen').forEach((r) => {
      let l = r.nextElementSibling && r.nextElementSibling.classList.contains('zl-g__leiste') ? r.nextElementSibling : null;
      const mehr = r.offsetParent && r.scrollWidth - r.clientWidth > 1;
      if (!mehr) { if (l) l.hidden = true; return; }
      if (!l) {
        l = document.createElement('div');
        l.className = 'zl-g__leiste';
        l.setAttribute('aria-hidden', 'true');
        l.append(document.createElement('span'));
        r.after(l);
        r.addEventListener('scroll', () => leisteZeichnen(r, l), { passive: true });
      }
      l.hidden = false;
      leisteZeichnen(r, l);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', leisten); else leisten();
  window.addEventListener('load', leisten);
  window.addEventListener('resize', leisten, { passive: true });
  document.addEventListener('zl:darunter', leisten);
  new MutationObserver(leisten).observe(document.documentElement, { attributes: true, attributeFilter: ['data-zl-darunter', 'data-zl-profil', 'data-zl-stil'] });

  /* ---------- Sechs Wochen: je Woche ein Feld, es füllt sich am Scrollen ----------
     Gemessen am Kapitel: von seiner Oberkante bei 70 % der Bildhöhe bis bei 10 %, jede Woche ein Sechstel davon. So füllt sich jede
     Woche einzeln unter dem Daumen, am Handy wie am Desktop, wo die Leiste im klebenden Kopf feststeht. Reduzierte Bewegung: voll. */
  const wochen = () => {
    const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.zl-g__zeitleiste').forEach((z) => {
      const k = z.closest('.zl-g__kapitel') || z, vh = window.innerHeight || 1;
      const p = ruhig ? 1 : Math.min(1, Math.max(0, (vh * 0.7 - k.getBoundingClientRect().top) / (vh * 0.6))); // token-ok: Weg des Kapitels in Bildhöhen
      Array.from(z.children).forEach((w, i, alle) => w.classList.toggle('ist-voll', p >= (i + 1) / alle.length));
    });
  };
  let wochenRaf = 0;
  window.addEventListener('scroll', () => { if (!wochenRaf) wochenRaf = requestAnimationFrame(() => { wochenRaf = 0; wochen(); }); }, { passive: true });
  window.addEventListener('resize', wochen, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wochen); else wochen();

  /* ---------- Marker (Regler "Unter dem Fold": nachtmarker, marker) ----------
     Antippen zieht den Strich neu, von links nach rechts. Nur wo gerade ein Marker zu sehen ist. */
  document.addEventListener('click', (e) => {
    const el = e.target.closest('.zl-g--weg [data-zl-g-mark]');
    if (!el || el.classList.contains('is-neu') || getComputedStyle(el, '::before').content === 'none') return; // ein Zug läuft zu Ende, Tippen dazwischen bleibt ohne Sprung
    const r = el.getBoundingClientRect();
    const rechts = e.clientX > r.left + r.width / 2;
    const links = 'inset(0 100% 0 0)'; // token-ok: ganz verdeckt, sichtbar wäre nur die linke Kante
    const rechtsZu = 'inset(0 0 0 100%)'; // token-ok: ganz verdeckt, sichtbar wäre nur die rechte Kante
    /* links getippt: zieht sich nach rechts zurück und legt sich von links neu. Rechts getippt: gespiegelt */
    el.style.setProperty('--strich-weg', rechts ? links : rechtsZu);
    el.style.setProperty('--strich-von', rechts ? rechtsZu : links);
    el.dataset.zlGText = el.textContent.trim();
    el.classList.add('is-neu');
  });
  document.addEventListener('animationend', (e) => { if (e.animationName === 'zl-g-strich') e.target.classList.remove('is-neu'); });
  /* Safari am iPhone zeigt :active nur, wenn die Seite auf Berührungen hört: Marker und Sticker rasten beim Antippen gerade ein */
  document.addEventListener('touchstart', () => {}, { passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', verteilen); else verteilen();
  new MutationObserver(verteilen).observe(document.documentElement, { attributes: true, attributeFilter: ['data-zl-bilder', 'data-zl-darunter'] });
  document.addEventListener('zl:darunter', verteilen);
})();
